
import { Vue } from "vue-class-component";

export default class WeightKg extends Vue {}
